export default __webpack_public_path__ + "static/media/fuel-station.6183b326.svg";